/*
 * https://github.com/vuejs/vue-loader/issues/1332#issuecomment-601572625
 */
import isRegexp from 'is-regexp'

function isDef(v) {
  return v !== undefined && v !== null
}
function isAsyncPlaceholder(node) {
  return node.isComment && node.asyncFactory
}
function getFirstComponentChild(children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i]
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}
function getComponentName(opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}
function matches(pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegexp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}
function remove(arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item)
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}
function pruneCacheEntry(cache, key, keys, current) {
  var cached$$1 = cache[key]
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy()
  }
  cache[key] = null
  remove(keys, key)
}
function pruneCache(keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache
  var keys = keepAliveInstance.keys
  var _vnode = keepAliveInstance._vnode
  // var aliveKeys = keepAliveInstance.aliveKeys
  const cachedNameKeyMap = keepAliveInstance.cachedNameKeyMap
  for (var key in cache) {
    var cachedNode = cache[key]
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions)
      if (name && !filter(name)) {
        // for (var aliveKey in cachedNameKeyMap[name]) {
        //   !aliveKeys.includes(aliveKey) &&
        //     pruneCacheEntry(cache, key, keys, _vnode)
        // }
        // cachedNameKeyMap[name] = null
        delete cachedNameKeyMap[name]
        pruneCacheEntry(cache, key, keys, _vnode)
      }
    }
  }
  // for (var key in cachedNameKeyMap) {
  //   for (var aliveKey in cachedNameKeyMap[key]) {
  //     if (!aliveKeys.includes(aliveKey)) {
  //       pruneCacheEntry(cache, aliveKey, keys, _vnode)
  //       delete cachedNameKeyMap[key][aliveKey]
  //     }
  //   }
  // }
}
const patternTypes = [String, RegExp, Array]
const KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number],
  },

  created() {
    this.cache = Object.create(null)
    // 修改原cachedNameKeyMap,变为二级对象，一级name，二级key
    this.cachedNameKeyMap = Object.create(null)
    this.keys = []
    // window.logCacheMap = () => {
    //   console.log(this.cachedNameKeyMap)
    // }
    // window.logCache = () => {
    //   console.log(this.cache)
    // }
    // window.logKeys = () => {
    //   console.log(this.keys)
    // }
    console.log('keep-alive created')
  },
  destroyed() {
    for (const key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys)
    }
  },
  mounted() {
    this.$watch('include', (val) => {
      pruneCache(this, (name) => matches(val, name))
    })
    this.$watch('exclude', (val) => {
      pruneCache(this, (name) => !matches(val, name))
    })
    this.$watch('aliveKeys', (val) => {
      for (const name in this.cachedNameKeyMap) {
        for (const key in this.cachedNameKeyMap[name]) {
          if (!val.includes(key)) {
            pruneCacheEntry(
              this.cache,
              this.cachedNameKeyMap[name][key],
              this.keys,
            )
          }
        }
      }
    })
  },
  computed: {
    aliveKeys() {
      return this.$store.state.viewTags.viewTags.map((item) => item.path)
    },
  },
  render() {
    const slot = this.$slots.default
    const vnode = getFirstComponentChild(slot)
    const componentOptions = vnode && vnode.componentOptions
    if (componentOptions) {
      // check pattern
      const name = getComponentName(componentOptions)
      const { include, exclude } = this
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }
      const { cache, cachedNameKeyMap, keys } = this
      const key =
        vnode.key == null
          ? // same constructor may get registered as different local components
            // so cid alone is not enough (#3269)
            componentOptions.Ctor.cid +
            (componentOptions.tag ? `::${componentOptions.tag}` : '')
          : vnode.key + componentOptions.Ctor.cid
      // console.log(cachedNameKeyMap)

      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance
        // make current key freshest
        remove(keys, key)
        keys.push(key)
      } else {
        cache[key] = vnode
        keys.push(key)
        // prune old component for hmr
        if (
          name &&
          cachedNameKeyMap[name] &&
          cachedNameKeyMap[name][vnode.key] &&
          cachedNameKeyMap[name][vnode.key] !== key
        ) {
          pruneCacheEntry(cache, cachedNameKeyMap[name][vnode.key], keys)
        }
        if (!isDef(cachedNameKeyMap[name])) {
          cachedNameKeyMap[name] = {}
        }
        cachedNameKeyMap[name][vnode.key] = key
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode)
        }
      }
      vnode.data.keepAlive = true
    }
    return vnode || (slot && slot[0])
  },
}
// ovveride original keep-alive
export default KeepAlive
